import {BaseService} from "@/api/baseService";

export interface FAQCategory<DateType = string> {
    createdAt: DateType;
    id: string;
    order: number;
    title: string;
    updatedAt: DateType;
}

export interface FAQ<DateType = string> {
    faqCategory: Pick<FAQCategory<DateType>, "id">;
    answer: string;
    createdAt: DateType;
    id: string;
    order: number;
    question: string;
    updatedAt: DateType;
}

export class FAQService extends BaseService {
    public static async getFAQCategories(): Promise<FAQCategory[]> {
        const response = await this.getData<FAQCategory[]>('/faqCategories', {orderBy: {order: 'asc'}});
        return response;
    }

    private static async getByParams(params?: any): Promise<FAQ[]> {
        const response = await this.getData<FAQ[]>("/faqs", params);
        return response;
    }

    public static async getByCategory(categoryId: string): Promise<FAQ[]> {
        return this.getByParams({where: {faqCategory: { id: categoryId}}});
    }

    public static async getAll(): Promise<FAQ[]> {
        return this.getByParams();
    }
}